import { Routes, Route } from 'react-router-dom';
import React, { createContext } from 'react';
import AboutLayout from './AboutLayout';
import AboutInfo from "./AboutInfo";
import AboutObjective from "./AboutObjective";

export const ThemeContext = createContext('light');

const About = () => {
    return (
        <ThemeContext.Provider value="dark">
            <Routes>
                <Route path="/" element={<AboutLayout />}>
                    <Route index element={<AboutInfo />} />
                    <Route path="objective" element={<AboutObjective />} />
                </Route>
            </Routes>
        </ThemeContext.Provider>
    );
};

export default About;
